// CONSTANTS
export const LOCAL_STORAGE_KEY_LUCKY_WHEEL_LAST_ID_MODAL = 'LUCKY_WHEEL_LAST_ID_MODAL';
export const LOCAL_STORAGE_FIRST_CASINO_VISIT = 'LUCKY_WHEEL_FIRST_CASINO_VISIT';

// LW STYLING FUNCTIONS
export const adjustColor = (color, amount) =>
    '#' +
    color
        .replace(/^#/, '')
        .replace(/../g, color =>
            ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).slice(-2)
        );

export const countRotation = (angle, spinningDuration) => {
    if (!angle) return;
    const rotateAngle = `${angle}deg`;
    return {
        transition: `transform ${spinningDuration}s cubic-bezier(0.42, 0, 0.04, 1.01)`,
        WebkitTransform: `rotate(${rotateAngle})`,
        MozTransform: `rotate(${rotateAngle})`,
        msTransform: `rotate(${rotateAngle})`,
        OTransform: `rotate(${rotateAngle})`,
        transform: `rotate(${rotateAngle})`
    };
};

export const countRandomDegree = numberOfSectors => {
    const segmentAngle = 360 / numberOfSectors;
    const maxAngleFromSegment = Math.floor(segmentAngle / 2 - segmentAngle / 10);
    const randomAngle = Math.random() * maxAngleFromSegment;
    const randomSign = -1 + Math.round(Math.random()) * 2;
    return randomAngle * randomSign;
};

export const playAudio = audio => {
    const sound = new Audio(audio);
    sound.play().catch(err => console.warn(err));
    return sound;
};
